/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ListMemoriesAppRequest} from '@cash-web/protos/squareup/cash/kgoosememorystore/api/v1beta1/app_service.pb'
import {ListMemoriesAppResponse} from '@cash-web/protos/squareup/cash/kgoosememorystore/api/v1beta1/app_service.pb'


export const listMemoriesApp = (request: ListMemoriesAppRequest, options?: CashRequestOptions) => post<ListMemoriesAppRequest, ListMemoriesAppResponse>("/2.0/cash/list-memories-app", request, {...options, rejectOnError: true })